import { ListOptionGroup } from '@ni/nimble-components/dist/esm/list-option-group';
import { wrap } from '../utilities/react-wrapper';

export { type ListOptionGroup };
export const NimbleListOptionGroup = wrap(ListOptionGroup);
